import { useRoutes, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Roles } from "@/enum/roles";
import { Suspense, lazy } from "react";

// Componente de loading
const LoadingFallback = () => <div>Carregando...</div>;

// Lazy loading dos componentes
const Login = lazy(() => import("@/pages/Login"));
const Home = lazy(() => import("@/pages/Home"));
const Notas = lazy(() => import("@/pages/dashboard"));
const ListaSecretarios = lazy(() => import("@/pages/secretario/Secretarios"));
const ListaProfessores = lazy(() => import("@/pages/professor/Professores"));
const ListaUsuarios = lazy(() => import("@/pages/Usuario/Usuarios"));
const ListaAlunos = lazy(() => import("@/pages/Aluno/Aluno"));
const ListaResponsaveis = lazy(() => import("@/pages/Responsavel/Responsavel"));
const ListaDisciplinas = lazy(() => import("@/pages/disciplina"));
const ListaSalas = lazy(() => import("@/pages/Sala/salas"));
const ListaTurmas = lazy(() => import("@/pages/Turmas/Turmas"));
const TurmaId = lazy(() => import("@/pages/Turmas/Turmas"));
const ListaPeriodos = lazy(() => import("@/pages/periodos"));
const ProfDashboard = lazy(() => import("@/pages/professor/dashboard"));
const ListaAulas = lazy(() => import("@/pages/Aulas/aulas"));
const ProfTurma = lazy(() => import("@/pages/professor/turma"));
const PageChamada = lazy(() => import("@/pages/professor/chamada"));
const PageLancarNotas = lazy(() => import("@/pages/Notas/alunosSala"));
const DashboardAluno = lazy(() => import("@/pages/Aluno/dashboard"));
const AlunoTurma = lazy(() => import("@/pages/Aluno/turma"));
//const AlunoBoletim = lazy(() => import("@/components/relatorios/boletim"));
const GradeAula = lazy(() => import("@/pages/Aluno/gradeaula"));
const ListaArquivos = lazy(() => import("@/pages/professor/Arquivos"));
const ListaTarefas = lazy(() => import("@/pages/professor/Tarefas"));
const ListaTarefasAluno = lazy(() => import("@/pages/Aluno/Tarefas"));
const Frequencias = lazy(() => import("@/pages/Relatorios/frequencia"));
const Receber = lazy(() => import("@/pages/Financeiro/Receber"));
const PageRealAulas = lazy(() => import("@/pages/Relatorios/relaulas"));
const PageListarTarefas = lazy(() => import("@/pages/Relatorios/listaTarefas"));
const ProfTarefas = lazy(() => import("@/pages/professor/listaTarefas"));

//ROTA DE NAVEGAÇÃO

// Componente wrapper para Suspense
const LazyComponent = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingFallback />}>{children}</Suspense>
);

export const AppRoutes = () => {
  const { user, loading } = useAuth();

  const getDefaultRoute = (nivel: string) => {
    switch (nivel) {
      case Roles.professor:
        return `/Professores/dashboard`;
      case Roles.secretaria:
      case Roles.admin:
      case Roles.funcionario:
        return "/dashboard";
      case Roles.aluno:
        return "/aluno/dashboard";
      default:
        return "/";
    }
  };

  const getRoutesByNivel = () => {
    const wrapRoute = (element: React.ReactElement) => ({
      element: <LazyComponent>{element}</LazyComponent>,
    });
    return [
      {
        path: "/",
        element: <Navigate to="/dashboard" />,
      },
      {
        path: "/dashboard",
        ...wrapRoute(<Home />),
      },
      {
        path: "/notas",
        ...wrapRoute(<Notas />),
      },
      {
        path: "/Secretarios",
        ...wrapRoute(<ListaSecretarios />),
      },
      {
        path: "/Professores",
        ...wrapRoute(<ListaProfessores />),
      },
      {
        path: "/Usuarios",
        ...wrapRoute(<ListaUsuarios />),
      },
      {
        path: "/Alunos",
        ...wrapRoute(<ListaAlunos />),
      },
      {
        path: "/Responsavel",
        ...wrapRoute(<ListaResponsaveis />),
      },
      {
        path: "/Disciplinas",
        ...wrapRoute(<ListaDisciplinas />),
      },
      {
        path: "/Salas",
        ...wrapRoute(<ListaSalas />),
      },
      {
        path: "/Turmas",
        ...wrapRoute(<ListaTurmas />),
      },
      {
        path: "/Turma/:id",
        ...wrapRoute(<TurmaId />),
      },
      {
        path: "/Aulas/:id",
        ...wrapRoute(<ListaAulas />),
      },
      {
        path: "/Periodos",
        ...wrapRoute(<ListaPeriodos />),
      },
      {
        path: "/Receber",
        ...wrapRoute(<Receber />),
      },
      {
        path: "/",
        element: <Navigate to={`/Professores/dashboard`} />,
      },
      {
        path: "/Professores/dashboard",
        ...wrapRoute(<ProfDashboard />),
      },
      {
        path: "/Professores/turma/:id",
        ...wrapRoute(<ProfTurma />),
      },
      {
        path: "/Professores/tarefas/:periodo/:turma",
        ...wrapRoute(<ProfTarefas />),
      },

      {
        path: "/Chamada/:id",
        ...wrapRoute(<PageChamada />),
      },
      {
        path: "/LancarNotas/:id",
        ...wrapRoute(<PageLancarNotas />),
      },

      {
        path: "/Arquivos/:turma_id/:sala_id",
        ...wrapRoute(<ListaArquivos />),
      },
      {
        path: "/Tarefas/:turma_id/:sala_id",
        ...wrapRoute(<ListaTarefas />),
      },
      {
        path: "/frequencia/:turma_id/:sala_id",
        ...wrapRoute(<Frequencias />),
      },
      {
        path: "/",
        element: <Navigate to="/aluno/dashboard" />,
      },
      {
        path: "/aluno/dashboard",
        ...wrapRoute(<DashboardAluno />),
      },
      {
        path: "/aluno/turma/:id",
        ...wrapRoute(<AlunoTurma />),
      },
      {
        path: "/aluno/grade/:sala_id",
        ...wrapRoute(<GradeAula />),
      },
      {
        path: "/aluno/tarefasaluna/:aluno_id",
        ...wrapRoute(<ListaTarefasAluno />),
      },
      {
        path: "/",
        element: <Navigate to="/dashboard" />,
      },
      {
        path: "/relaulas",
        ...wrapRoute(<PageRealAulas />),
      },
      {
        path: "/listatarefas",
        ...wrapRoute(<PageListarTarefas />),
      },
      {
        path: "/dashboard",
        ...wrapRoute(<Home />),
      },
    ];
  };

  const routes = [
    {
      path: "/",
      element: !user ? (
        <LazyComponent>
          <Login />
        </LazyComponent>
      ) : (
        <Navigate to={getDefaultRoute(user.nivel)} />
      ),
    },
    ...getRoutesByNivel(),
    {
      path: "*",
      element: <Navigate to="/" />,
    },
  ];

  const element = useRoutes(routes);

  if (loading) {
    return <LoadingFallback />;
  }

  return element;
};
